import { Pagination } from "react-admin";

export const DefaultPagination = (props) => {
    return <Pagination rowsPerPageOptions={[50, 100, 200]} {...props} />;
};
